"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceZombie = exports.getPredictableDeviceZombies = exports.significantFigures = exports.roundDecimals = exports.commaStringNumber = exports.getTrackLength = exports.getAverage = exports.getTotal = exports.getValueLabel = exports.isLocatable = exports.extractPathFromOrderedThingStateShadowZombies = exports.getPositionFromTSS = exports.extractAllStateAttributes = exports.getDynamoKeysFromVobs = exports.getDynamoKeyFromNodeOrEdge = exports.getDynamoKeyFromVob = exports.getDynamoKeyFromPrimaryKey = exports.getDatastoreObjectKeyFromPrimaryKey = exports.getZombieInstanceFromAttributes = exports.getMinimalVOB = exports.getZombieEdge = exports.getPredictableZombies = exports.getZombieInstanceFromPrimaryKey = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const ModelTypes_1 = require("../types/ModelTypes");
const TurfUtils_1 = require("./geo/TurfUtils");
const helpers_1 = require("@turf/helpers");
const length_1 = require("@turf/length");
const hex_1 = require("./hex");
const identity_1 = require("./objects/identity");
const lambda_1 = require("./lambda");
const uuid_1 = require("uuid");
var iotv_v3_types_2 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "getZombieInstanceFromPrimaryKey", { enumerable: true, get: function () { return iotv_v3_types_2.getZombieInstanceFromPrimaryKey; } });
Object.defineProperty(exports, "getPredictableZombies", { enumerable: true, get: function () { return iotv_v3_types_2.getPredictableZombies; } });
Object.defineProperty(exports, "getZombieEdge", { enumerable: true, get: function () { return iotv_v3_types_2.getZombieEdge; } });
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const { projectCode, stage } = process.env;
/** returns cloned object with sk, pk, name, id, type plus any addtional keys from input object */
const getMinimalVOB = (vob, additionalKeys) => {
    const { sk, pk, name, id, type } = vob;
    const res = { sk, pk, name, id, type };
    if (additionalKeys) {
        additionalKeys.forEach((k) => {
            if (vob[k]) {
                res[k] = vob[k];
            }
        });
    }
    return res;
};
exports.getMinimalVOB = getMinimalVOB;
//** v-0-2-0 hack?? */
/** DEPRECATION WARNING
 * This vxxx (20) hack is specific to devices and will be removed
 */
const getZombieInstanceFromAttributes = (pk, sk, networkKey, applicationId) => {
    if (!sk) {
        sk = pk;
    }
    const [type, ...idOthers] = pk.split(':');
    const id = idOthers.join(':');
    const zombie = { type, id, sk: sk, pk: pk };
    zombie.appID = applicationId;
    zombie.networkKey = networkKey;
    return zombie;
};
exports.getZombieInstanceFromAttributes = getZombieInstanceFromAttributes;
const getDatastoreObjectKeyFromPrimaryKey = (pk) => {
    const key = { pk, sk: pk };
    return key;
};
exports.getDatastoreObjectKeyFromPrimaryKey = getDatastoreObjectKeyFromPrimaryKey;
const getDynamoKeyFromPrimaryKey = (pk) => {
    const key = { pk, sk: pk };
    return key;
};
exports.getDynamoKeyFromPrimaryKey = getDynamoKeyFromPrimaryKey;
/** Gets the key for the primary object. DOES NOT WORK FOR EDGES AS THIS WAS ORIGINALLY DONE AS SHORTCUT */
const getDynamoKeyFromVob = (vob) => {
    const key = { pk: vob.pk, sk: vob.pk };
    return key;
};
exports.getDynamoKeyFromVob = getDynamoKeyFromVob;
/** gets the dynamodb key { sk, pk } from any VOB */
const getDynamoKeyFromNodeOrEdge = (vob) => {
    const key = { pk: vob.pk, sk: vob.sk };
    return key;
};
exports.getDynamoKeyFromNodeOrEdge = getDynamoKeyFromNodeOrEdge;
const getDynamoKeysFromVobs = (vobs) => vobs.map((vob) => (0, exports.getDynamoKeyFromNodeOrEdge)(vob));
exports.getDynamoKeysFromVobs = getDynamoKeysFromVobs;
const extractAllStateAttributes = function () {
    const metrics = this?.payload?.state?.reported;
    const calculated = this?.payload?.state?.calculated;
    return Object.assign({}, metrics, calculated);
};
exports.extractAllStateAttributes = extractAllStateAttributes;
const getPositionFromTSS = (item) => {
    const position = item?.payload?.state?.reported?.position || item?.state?.reported?.position;
    return position;
};
exports.getPositionFromTSS = getPositionFromTSS;
const extractPathFromOrderedThingStateShadowZombies = (tssZombies) => {
    const track = tssZombies.map((tss) => tss?.payload?.state?.reported?.position).filter((latLon) => (0, ModelTypes_1.isGeofencePointsType)(latLon));
    return track;
};
exports.extractPathFromOrderedThingStateShadowZombies = extractPathFromOrderedThingStateShadowZombies;
const isLocatable = (item) => {
    return item && ((0, iotv_v3_types_1.isPosition)(item.location) || (0, iotv_v3_types_1.isIGeofence)(item));
};
exports.isLocatable = isLocatable;
const getValueLabel = (text) => text
    .toLowerCase()
    .split('_')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
exports.getValueLabel = getValueLabel;
const getTotal = (states, key) => {
    let initial = 0, count = 0, noCount = 0;
    const reducer = (initial, tss, i) => {
        const metrics = exports.extractAllStateAttributes.call(tss);
        if (metrics[key] && typeof metrics[key] === 'number') {
            count++;
            return (initial += metrics[key]);
        }
        else {
            noCount++;
            return initial;
        }
    };
    const total = states.reduce(reducer, initial);
    return { total, count, noCount };
};
exports.getTotal = getTotal;
const getAverage = (states, key) => {
    const totalPlus = (0, exports.getTotal)(states, key);
    const average = totalPlus.count === 0 ? 0 : totalPlus.total / totalPlus.count;
    return { average, ...totalPlus };
};
exports.getAverage = getAverage;
const getTrackLength = (states) => {
    const n = 3; // approx 1m
    const gPath = (0, exports.extractPathFromOrderedThingStateShadowZombies)(states);
    const tPath = (0, TurfUtils_1.convertGPointsToTPosition)(gPath);
    debug && console.log('tPath is', tPath);
    let d = 0;
    if (tPath instanceof Array && tPath.length > 0) {
        const line = (0, helpers_1.lineString)(tPath);
        d = (0, length_1.length)(line, { units: 'kilometers' });
    }
    return (0, exports.roundDecimals)(d, n);
};
exports.getTrackLength = getTrackLength;
const commaStringNumber = (number) => {
    let x = number.toString();
    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
        x = x.replace(pattern, '$1,$2');
    return x;
};
exports.commaStringNumber = commaStringNumber;
const roundDecimals = (n, d) => Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
exports.roundDecimals = roundDecimals;
/**
 * Function to round a number to x significant figures
 * @param n number to round
 * @param sig number of significant figures. Default is 3
 * @param number if you want a string or number result. Default is string
 * @returns
 */
const significantFigures = (n, sig = 3, number = false) => {
    if (sig === 0) {
        return n;
    }
    else {
        let res = Number(n.toPrecision(sig));
        if (number) {
            return res;
        }
        return res.toLocaleString();
    }
};
exports.significantFigures = significantFigures;
/** @deprecated - do not use except in testing/utilities.
 * THIS IS NOT SAFE WITH EUI NUMBER VALUES PARSED FROM STRINGS WHERE RESULT IS GREATER THAN Number.MAX_SAFE_INTERGER! */
const getPredictableDeviceZombies = ({ deviceType, appID, networkKey, _permittedAWOL, numberOfDevices, devEuiLength = 16, deviceEUIStart = 0x451000000, }) => {
    const deviceNamePrefix = 'Device';
    const mutateZombie = (zombie, idx) => {
        const eui = (0, hex_1.getNLengthHex)(devEuiLength, deviceEUIStart + idx);
        const name = `${deviceNamePrefix} ${eui}`;
        const appKey = (0, hex_1.getNLengthHex)(32, 99999);
        const appEui = (0, hex_1.getNLengthHex)(16, Math.round(Math.random() * 100000000000000));
        const deviceId = networkKey === iotv_v3_types_1.Networks.AWS_LPWAN ? (0, uuid_1.v4)() : eui.substring(eui.length - 4);
        const mutant = (0, identity_1.reKeyItem)(zombie, eui);
        Object.assign(mutant, { name, eui, appID, networkKey, appEui, appKey, deviceId, _permittedAWOL });
        return mutant;
    };
    const zombieDevices = (0, iotv_v3_types_1.getPredictableZombies)('Device', numberOfDevices, { deviceType });
    return zombieDevices.map((dev, i) => mutateZombie(dev, i));
};
exports.getPredictableDeviceZombies = getPredictableDeviceZombies;
/** @deprecated - do not use except in testing/utilities.
 * THIS IS NOT SAFE WITH EUI NUMBER VALUES PARSED FROM STRINGS WHERE RESULT IS GREATER THAN Number.MAX_SAFE_INTERGER! */
const getDeviceZombie = ({ deviceType, eui, appID = 'MockApp', networkKey, _permittedAWOL }) => {
    return (0, exports.getPredictableDeviceZombies)({ appID, devEuiLength: 16, deviceEUIStart: eui, deviceType, networkKey, numberOfDevices: 1, _permittedAWOL })[0];
};
exports.getDeviceZombie = getDeviceZombie;
